import type {GammaSockets} from "#material/nodes/color/gamma/definition"
import type {MaterialNodeParameters, MaterialNodeSettings} from "#material/sockets/parameters"
import type {Version} from "@cm/graph-v3"

type Current = MaterialNodeParameters<GammaSockets>
type Previous = Omit<Current, "settings"> & {settings: MaterialNodeSettings<GammaSockets> & {disabled?: boolean}}

/** Muting a node is ui.disabled, which every renderer reads and the exchange format carries as internal.mute. */
export const dropDisabledNoRendererReads: Version<Previous, Current> = {
    toNextVersion: ({settings: {disabled, ...settings} = {}, ...parameters}) => ({...parameters, settings}),
}
